export default __webpack_public_path__ + "images/38905d07050c4a4a04dc76d4d2688f6a.svg";